export default "__VITE_ASSET__BnpuI2sk__"